export class OnlineOrderUrlModel implements OLO.DTO.OnlineOrderUrlBusinessModel {
    public UrlType: APICommon.ORDER_URL_TYPE = APICommon.ORDER_URL_TYPE.ORDER_CONFIRMATION;

    constructor(
        public OrderId: number,
        public Url: string,
    ) { }
}
